import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShared = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15.679 5.464c0 .893-.364 1.7-.951 2.283a6.1 6.1 0 0 1 1.85 1.329c1.013 1.059 1.672 2.479 1.672 3.888a.75.75 0 0 1-1.5 0c0-.957-.46-2.02-1.256-2.85-.79-.827-1.854-1.364-2.994-1.364h-.75a3.62 3.62 0 0 1-1.764 2.913c2.568.682 4.53 2.748 4.53 5.337a.75.75 0 1 1-1.5 0c0-2.148-2.073-4.078-4.883-4.078S3.25 14.852 3.25 17a.75.75 0 1 1-1.5 0c0-2.589 1.963-4.655 4.531-5.337A3.621 3.621 0 0 1 9.269 5.11a3.215 3.215 0 0 1 6.41.353Zm-4.72.82a1.714 1.714 0 1 1 .24.336 4 4 0 0 0-.24-.336m-.981 1.217a2.121 2.121 0 1 1-.251-.352q.114.185.25.352Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShared;
